import { NavListItem, NavListItemProps } from '.';

export const NavListItemSecondary = (props: NavListItemProps) => (
  <NavListItem className="text-p-16" directory={false} {...props} />
);
